import React from 'react';
import v from 'vudu';
import Tick from './svgs/Tick';
import { styles as s, colors } from 'stylesheet';
import OvalRimImage from 'assets/OvalRim.svg';

const OPTION_INPUT_SIZE = 20;

const localClasses = v({
  optionInput: {
    flex: 'none',
    appearance: 'none',
    top: '4px',
    right: 0,
    bottom: 0,
    left: 0,
    height: `${OPTION_INPUT_SIZE}px`,
    width: `${OPTION_INPUT_SIZE}px`,
    transition: 'all 150ms ease-out',
    background: 'transparent',
    border: '1.5px solid grey',
    cursor: 'pointer',
    display: 'inline-block',
    marginRight: '0.5rem',
    outline: 'none',
    zIndex: 1,
    borderRadius: '50%',
    opacity: 0.4,
    ':hover': {
      border: '1.5px solid white',
    },
    ':checked': {
      opacity: 1,
      '+ svg': { opacity: 1 },
      '+ img': { opacity: 0 },
      background: colors.byzantine,
      border: `1.5px solid ${colors.byzantine}`,
    },
  },
  checkWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionInputLabel: {
    display: 'flex',
    alignItems: 'center',
    '@composes': [s.relative, s.white],
    fontSize: '16px',
    position: 'relative',
    'svg': {
      flex: 'none',
      transition: 'all 150ms ease-out',
      position: 'absolute',
      opacity: 0,
      top: '8px',
      left: '6px',
      zIndex: 3,
    },
    'img': {
      '@keyframes optionSpinner': {
        'to': { transform: 'rotate(360deg)' }
      },
      animation: 'optionSpinner 1.2s ease-out infinite',
      position: 'absolute',
      left: '-3.7px',
      opacity: 0
    },
    ':hover:not(.checked)': {
      'img': { opacity: 0.6 }
    },
  },
  active: {
    '@composes': [s.byzantine]
  },

});

export default props => {
  let wrapper = localClasses.optionInputLabel;
  if (props.checked) wrapper += ` checked ${localClasses.active}`;
  return (
    <label className={wrapper}>
      <span className={localClasses.checkWrapper}>
        <input
          type="checkbox"
          className={localClasses.optionInput}
          checked={props.checked}
          onClick={props.onClick}
        />
        <Tick className={localClasses.tick} stroke={colors.ebony} />
        <img src={OvalRimImage} />
      </span>
      {props.children}
    </label>
  )
};



// WEBPACK FOOTER //
// ./src/components/PanelOptionInput.js